// extracted by mini-css-extract-plugin
export default {"sso_button_google":"FirebaseGoogleSignInButton_sso_button_google__cwt2s","sso_button_google_icon":"FirebaseGoogleSignInButton_sso_button_google_icon__4FxQo"};